function share() {
    const container = document.querySelector('[data-share]');
    if (!container) return;

    const url = encodeURIComponent(window.location.href.split('#')[0]);
    const title = encodeURIComponent(container.dataset.shareTitle || document.title);
    const image = encodeURIComponent(container.dataset.shareImage || '');

    const links = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
        x: `https://x.com/intent/post?url=${url}&text=${title}`,
        pinterest: `https://pinterest.com/pin/create/button/?url=${url}&media=${image}&description=${title}`,
        email: `mailto:?subject=${title}&body=${url}`
    };

    container.querySelectorAll('[data-share-network]').forEach(function (link) {
        const href = links[link.dataset.shareNetwork];
        if (href) link.href = href;
    });

    const copy = container.querySelector('[data-share-copy]');
    if (copy && navigator.clipboard) {
        copy.addEventListener('click', async function () {
            try {
                await navigator.clipboard.writeText(decodeURIComponent(url));
                copy.classList.add('is-copied');
                setTimeout(() => copy.classList.remove('is-copied'), 2000);
            } catch (e) {
                // Clipboard access denied, nothing to do
            }
        });
    } else if (copy) {
        copy.remove();
    }
}
